import { createWebHistory, createRouter } from "vue-router";
import store from './store';
import Home from "./components/Home.vue";
import Login from "./components/Login.vue";
import Register from "./components/Register.vue";
// lazy-loaded
const Profile = () => import("./components/Profile.vue")
const BoardAdmin = () => import("./components/BoardAdmin.vue")
const BoardModerator = () => import("./components/BoardModerator.vue")
const BoardUser = () => import("./components/BoardUser.vue")
const Main = () => import("./components/Main.vue")
const TodoListMain = () => import("./components/TodoList/TodoListMain.vue")
const Omok = () => import("./components/Omok.vue")
const Share = () => import("./components/Share.vue")
import TestPage from "./components/TestPage.vue"


const routes = [
    {
        path: "/",
        name: "home",
        component: Home,
    },
    {
        path: "/home",
        component: Home,
    },
    {
        path: "/login",
        component: Login,
    },
    {
        path: "/register",
        component: Register,
    },
    {
        path: "/profile",
        name: "profile",
        // lazy-loaded
        component: Profile,
    },
    {
        path: "/main",
        name: "main",
        // lazy-loaded
        component: Main,
        meta: {
            reload:true,
        },
    },
    {
        path: "/admin",
        name: "admin",
        // lazy-loaded
        component: BoardAdmin,
    },
    {
        path: "/mod",
        name: "moderator",
        // lazy-loaded
        component: BoardModerator,
    },
    {
        path: "/user",
        name: "user",
        // lazy-loaded
        component: BoardUser,
    },
    {
        path: "/Omok",
        name: "Omok",
        // lazy-loaded
        component: Omok,
    },
    {
        path: "/TestPage",
        //name: "testImage",
        // lazy-loaded
        component: TestPage,
    },
    {
        path: "/todoList",
        name: "todoList",
        // lazy-loaded
        component: TodoListMain,
    },
    {
        path: "/share/page/:token",
        //path: "/share",
        name: "share",
        component: Share, // ���� �������� �� ������Ʈ
        meta: {
            hideLayout: true,
            reload: true,
        },
        props: true // id�� props�� �ޱ� ����
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});


router.beforeEach((to, from, next) => {
    if (to.path.startsWith('/share')) {
        return next();
    }

    const token = store.state.auth.user?.accessToken;
    const user = store.state.auth.user;

    if ((!token || !user) && to.path !== '/login') {
        return next('/login');
    }

    if ((to.path === '/login' || to.path === '/') && token) {
        return next('/home');
    }

    next();
});

export default router;